import axios from 'axios'
import store from '../store'

// import Vue from 'vue'

const state = {
  agencyFromEmail: 'goldcoastnannies@enginehire.io',
  agencyReplyEmail: 'sarah@goldcoastnannies.company',
  enginehireAdminEmail: 'aakash@enginehire.ca',
  enginehireLoggingEmail: 'enginehirelogs@gmail.com',

  agencyAdminEmail: 'sarah@goldcoastnannies.company',
  agencyAdminEmail2: 'bridget@goldcoastnannies.company',

  // agencyAdminEmail: 'aakash@enginehire.io',
  // agencyAdminEmail2: 'aakash@enginehire.io',

  // agencyAdminEmail: process.env.NODE_ENV.includes('development') ? 'aakash@enginehire.io' : 'sarah@goldcoastnannies.company',
  // agencyAdminEmail2: process.env.NODE_ENV.includes('development') ? 'aakash@enginehire.io' : 'bridget@goldcoastnannies.company',
};

const mutations = {

};

const actions = {
  sendEmail({commit, dispatch}, emailInfo) {
    console.log(emailInfo.email)
    console.log(emailInfo.userID)

    let message = emailInfo.message
    // If we are sending an html email we want to add the tags and the footer
    if (emailInfo.html) {
      // message = '<html><head></head><body>'+emailInfo.message+'<img src="https://s3.us-east-2.amazonaws.com/pinknannies.enginehire.io/PN+E-mail+signature-01.png"></body></html>'
      message = '<html><head></head><body>'+emailInfo.message+'</body></html>'
    }

    axios.post('/optimum/email/',
        {
          subject: emailInfo.subject,
          // message: emailInfo.message,
          message: message,
          from_address: emailInfo.from,
          to_address: emailInfo.email,
          reply_address: emailInfo.reply,
          user_id: emailInfo.userID,
        }
      )
        .then(res => {
          console.log('Email Sent')
          console.log(res)

          dispatch('logEmail',
            {
              subject: emailInfo.subject,
              message: emailInfo.message,
              from_address: emailInfo.from,
              to_address: res.data.email,
              reply_address: emailInfo.reply,
              user_id: emailInfo.userID,
            }
          ) // Lecture 360
        })
        .catch(error => console.log(error))
  },

  sendEmails({commit, dispatch}, emailInfo) {
    //
    // Send the same email to a list of several emails
    //
    console.log(emailInfo.emails)
    console.log(emailInfo.userID)
    for (var emailIndex in emailInfo.emails) {
      // console.log(emailInfo.emails)
      // console.log(emailIndex)
      // console.log(emailInfo.emails[emailIndex])

      let message = emailInfo.message
      // If we are sending an html email we want to add the tags and the footer
      if (emailInfo.html) {
        // message = '<html><head></head><body>'+emailInfo.message+'<img src="https://s3.us-east-2.amazonaws.com/pinknannies.enginehire.io/PN+E-mail+signature-01.png"></body></html>'
        message = '<html><head></head><body>'+emailInfo.message+'</body></html>'
      }

      axios.post('/optimum/email/',
        {
          subject: emailInfo.subject,
          // message: emailInfo.message,
          message: message,
          from_address: emailInfo.from,
          to_address: emailInfo.emails[emailIndex],
          reply_address: emailInfo.reply,
          user_id: emailInfo.userID,
        }
      )
        .then(res => {
          console.log('Email Sent to ' + res.data.email)
          // console.log('Email Sent to ' + emailInfo.emails[emailIndex])
          // console.log(emailInfo.emails)
          // console.log(emailIndex)
          // console.log(emailInfo.emails[emailIndex])
          // console.log(res)
          dispatch('logEmail',
            {
              subject: emailInfo.subject,
              message: emailInfo.message,
              from_address: emailInfo.from,
              to_address: res.data.email,
              reply_address: emailInfo.reply,
              user_id: emailInfo.userID,
            }
          ) // Lecture 360
        })
        .catch(error => console.log(error))
    }
  },

  logEmail({commit, dispatch}, emailInfo) {
    console.log('Logging Email')
    console.log(emailInfo)
    console.log(emailInfo.to_address)
    console.log(store.getters.userID)
    if (emailInfo.to_address != state.enginehireAdminEmail && emailInfo.to_address != state.enginehireLoggingEmail) { // Don't want to log emails sent to enginehire admin
      axios.post('/api/emaillogs/', {
        recipient: emailInfo.user_id,
        sender: store.getters.userID,
        subject: emailInfo.subject,
        body: emailInfo.message,
        to_email: emailInfo.to_address,
        from_email: emailInfo.from_address,
        reply_email: emailInfo.reply_address,
        agency_owner: store.getters.agencyName,
        agency: store.getters.agencyID,
      })
        .then(res => {
          console.log(res)
          console.log('Email logged!')
        })
        .catch(error => console.log(error))
    }
  },

  // sendSMS({commit, dispatch}, SMSInfo) {
  //   console.log(SMSInfo)
  //   axios.post('/optimum/email/',
  //       {
  //         subject: emailInfo.subject,
  //         message: emailInfo.message,
  //         from_address: emailInfo.from,
  //         to_address: emailInfo.email,
  //         reply_address: emailInfo.reply,
  //         user_id: emailInfo.userID,
  //       }
  //     )
  //       .then(res => {
  //         console.log('Email Sent')
  //         console.log(res)

  //         dispatch('logSMS',
  //           {
  //             subject: emailInfo.subject,
  //             message: emailInfo.message,
  //             from_address: emailInfo.from,
  //             to_address: res.data.email,
  //             reply_address: emailInfo.reply,
  //             user_id: emailInfo.userID,
  //           }
  //         ) // Lecture 360
  //       })
  //       .catch(error => console.log(error))
  // },

  // commsAlive() {
  //   console.log('Comms Alive!!')
  // },
  // sendMasivSMS({commit}, SMSInfo) {
  //   console.log('Sending Masiv SMS')
  //   console.log(SMSInfo)

  //   // axios.post('https://api.masiv.co/SmsHandlers/sendhandler.ashx?action=sendmessage&username=Api_5_A73&password=6DZW7HHFQ0&recipient='+SMSInfo.phone+'&originator=3508830809&messagedata='+SMSInfo.message+'&longMessage=true&flash=false&premium=false')
  //   axios.post('https://cors-anywhere.herokuapp.com/https://api.masiv.co/SmsHandlers/sendhandler.ashx?action=sendmessage&username=Api_5_A73&password=6DZW7HHFQ0&recipient='+SMSInfo.phone+'&originator=3508830809&messagedata='+SMSInfo.message+'&longMessage=true&flash=false&premium=false')
  //     .then(res => {
  //       console.log(res)
  //     })
  //     .catch(error => console.log(error))
  // },
};

const getters = {
  agencyFromEmail (state) {
    return state.agencyFromEmail
  },
  agencyReplyEmail (state) {
    return state.agencyReplyEmail
  },
  enginehireAdminEmail (state) {
    return state.enginehireAdminEmail
  },
  enginehireLoggingEmail (state) {
    return state.enginehireLoggingEmail
  },
  agencyAdminEmail (state) {
    return state.agencyAdminEmail
  },
  agencyAdminEmail2 (state) {
    return state.agencyAdminEmail2
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/communication.js